export type RouteVisibilityMap = Record<string, boolean>

/**
 * Single source of truth for what is hidden vs shown.
 * - Edit only this file to hide or show a route.
 * - Nav and the global route guard both read from here (no per-route wrappers needed).
 *
 * - true  => route is enabled (shown in nav, resolves normally)
 * - false => route is disabled (hidden from nav, 404 on direct access)
 * - Path not present => treated as enabled.
 *
 * Branch hiding: use a key ending with "/*" to enable/disable a full path branch.
 * Example: '/software/vertical/*': false  hides /software/vertical and all children.
 * Longest matching branch wins over shorter ones.
 */
export const routeVisibility: RouteVisibilityMap = {
  // ─── Root ─────────────────────────────────────────────────────────────────
  '/': true,
  '/about': true,

  // ─── Services (menu order) ────────────────────────────────────────────────
  '/services': true,
  '/services/*': false,
  '/services/gtm': true,
  '/services/advisory': true,
  //SET UP ADVISOTRY SERVICE
  // SET UP GTM/EXPANSION SERVICE 
  // '/services/consulting': true,
  // '/services/consulting/startup': true,
  // '/services/consulting/design': true,
  // '/services/consulting/frameworks': true,
  // '/services/consulting/revenue': true,
  // '/services/consulting/operations': true,
  // '/services/consulting/assessment': true,
  // '/services/research': true,
  // '/services/research/government': true,
  // '/services/research/academic': true,
  // '/services/research/private': true,

  // ─── Investment Division (menu order) ────────────────────────────────────
  '/investment': true,
  '/investment/strategies': true,
  '/investment/strategies/venture': true,
  '/investment/strategies/pe': true,
  '/investment/strategies/quant': false,
  '/investment/strategies/systematic': false,
  '/investment/strategies/fundamental': false,
  '/investment/strategies/energy': true,
  '/investment/digital-funds': false,
  '/investment/digital-funds/*': false,
  '/investment/instruments': false,
  '/investment/instruments/*': false,
  // '/investment/instruments/derivatives': true,
  // '/investment/instruments/commodities': true,
  // '/investment/instruments/tokens': true,
  '/investment/services': false,
  '/investment/services/*': false,
  // '/investment/services/banking': true,
  // '/investment/services/insurance': true,
  // '/investment/services/managed-portfolios': true,
  // '/investment/services/private-wealth': true,
  // '/investment/services/rsu-liquidity': true,
  // '/investment/services/equity-compensation-insurance': true,
  // '/investment/services/equity-backed-lending': true,
  // '/investment/services/real-estate-financing': true,
  // '/investment/services/green-franchises': true,
  // '/investment/services/energy-farms': true,
  // '/investment/services/vertical-farms': true,
  // '/investment/services/green-houses': true,
  // '/investment/services/distressed-real-estate': true,
  // '/investment/services/asset-management': true,

  // ─── Software & Technology (menu order) ───────────────────────────────────
  '/software': true,
  '/software/darden': true,
  '/software/darden/app': true,
  '/software/darden/darden': false,
  '/software/darden/trato': true,
  '/software/darden/portal': true,
  '/software/darden/sambbi': true,
  '/software/darden/tienda': false,
  '/software/darden/mgt': false,
  '/software/darden/onwheels': false,
  '/software/darden/troppa': true,
  '/software/darden/deneflitz': true,
  '/software/darden/mercanti': false,
  '/software/darden/ressi': true,
  '/software/darden/roomaid': false,
  '/software/darden/flytrap': false,
  '/software/darden/sprinkle': false,
  '/software/vertical': true,
  '/software/vertical/insurance': false,
  '/software/vertical/insurance-and-benefits': false,
  '/software/vertical/estate': false,
  '/software/vertical/cleo': false,
  '/software/vertical/checkacv': false,
  '/software/vertical/ssimpleauth': true,
  '/software/vertical/sentium': false,
  '/software/vertical/lectu': false,
  '/software/vertical/scavanger': false,
  '/software/vertical/flota': false,
  '/software/vertical/ovelto': false,
  '/software/vertical/tinta': false,
  // Tinta payments aka tinta send/receive (consumer prod) -> 1. tinta budget 2. tinta card (can be placed in any gig app) 3. tinta for biz?
  '/software/institutional': true,
  '/software/institutional/sdi': false,
  // should be "/isdi" Syphen ISDI: Investment Software & Data Intelligence
  '/software/institutional/syphen': true,
    // should be "/IR" Syphen IR: Investment Software & Data Intelligence
  '/software/institutional/creditosn': true,
    // should be "/creditosn" Syphen Creditos^n: Investment Software & Data Intelligence
  '/software/institutional/esg': true,
   // should be "/direct-indexing" Syphen DIRECT :
  '/software/institutional/ib': true,
    // should be "/IB" Syphen IB: Provide M&A and Investment Services
  '/software/api': true,
  '/software/api/insurance': false,
  '/software/api/embeddable-insurance': false,
  '/software/api/stable-coins': true,
  // STABLECOINS API → TINTA.DEV:  stablecoin api
  '/software/digital-funds': false,
  '/software/digital-funds/*': false,
  // '/software/digital-funds/etp': true,
  // '/software/digital-funds/farmlands': true,
  // '/software/digital-funds/reits': true,
  // '/software/digital-funds/credit': true,
  // '/software/digital-funds/opportunity-zones': true,
  // '/software/digital-funds/bonds': true,
  // '/software/digital-funds/infrastructure': true,
  // '/software/digital-funds/volatility': true,
  // '/software/digital-funds/commodities': true,
  // '/software/digital-funds/media': true,
  // '/software/digital-funds/smart-cities': true,
  // '/software/digital-funds/alternatives': true,

  // ─── Insights (menu order) ────────────────────────────────────────────────
  '/insights': false,
  '/insights/*': false,
  // '/insights/feed': true,
  // '/insights/blog': true,
  // '/insights/blog/all': true,
  // '/insights/blog/opinion': true,
  // '/insights/blog/partner': true, 
  //SET UP AS "/BLOG/PARTNERS"
  // '/insights/blog/announcements': true,
  // '/insights/shared': true,
  // '/insights/shared/reports': true,
  // '/insights/shared/learning': true,
  // '/insights/shared/news': true,
  // '/insights/shared/research': true,
  // '/insights/reports': true,
  // '/insights/reports/industry': true,
  // '/insights/reports/learning': true,
  // '/insights/reports/news': true,
  // '/insights/reports/research': true,

  // ─── Community ────────────────────────────────────────────────────────────
  '/community': false,
  '/community/*': false,
  // '/community/fuel-reality': true,
  // '/community/alphazillenial': false,
  // '/community/crypto-union': false,
  // '/community/freelancer-fund': false,

  // ─── Footer / standalone ──────────────────────────────────────────────────
  '/careers': true,
  '/contact': true,
  '/newsletter': true,
  '/privacy': true,
  '/terms': true,
  '/article': true,
  '/podcast': true,
  '/vid': true,
}

/**
 * Returns whether a route is enabled. Supports exact paths and branch keys ending with "/*".
 * Example: '/software/vertical/*': false disables /software/vertical and everything under it.
 */
export function isRouteEnabled(path: string): boolean {
  const exact = routeVisibility[path]
  if (typeof exact === 'boolean') return exact

  // Normalize: ensure path has leading slash, no trailing slash (except for root)
  const normalized = path === '' ? '/' : path.startsWith('/') ? path.replace(/\/$/, '') || '/' : `/${path.replace(/\/$/, '')}`

  const exactNormalized = routeVisibility[normalized]
  if (typeof exactNormalized === 'boolean') return exactNormalized

  // Find longest matching branch key (e.g. "/software/vertical/*")
  const branchKeys = (Object.keys(routeVisibility) as string[]).filter((k) => k.endsWith('/*'))
  let bestPrefix: string | null = null
  for (const key of branchKeys) {
    const prefix = key.slice(0, -2)
    if (normalized === prefix || normalized.startsWith(prefix + '/')) {
      if (bestPrefix === null || prefix.length > bestPrefix.length) bestPrefix = prefix
    }
  }
  if (bestPrefix !== null) {
    const branchKey = `${bestPrefix}/*`
    const branchValue = routeVisibility[branchKey]
    if (typeof branchValue === 'boolean') return branchValue
  }

  return true
}
